import {NinchatMessages} from '../api/types'
import {NinchatStore} from 'api/types'

export default class HighlightRegExp extends RegExp {
    constructor(highlights: string | string[], flags: string) {
        const pattern = (Array.isArray(highlights) ? highlights : [highlights]).reduce((items: string[], item) => {
            if (!item.trim()) {
                return items
            }

            const rema = item.match(/^(?<prefix>\*|)(?<search>.*?)(?<suffix>\*|)$/u)
            const term = [
                rema?.groups?.prefix ? '' : '(?<=^|\\s|[\'"`])',
                rema?.groups?.search,
                rema?.groups?.suffix ? '' : '(?=$|\\s|[\'"`])',
            ].join('')

            items.push(term)

            return items
        }, []).join('|') || /[]/u // eslint-disable-line no-empty-character-class

        super(pattern, flags)
    }

    test(message: string | NinchatStore.NinchatStoreMessage): boolean {
        super.lastIndex = 0

        if (typeof message === 'string') {
            return super.test(message)
        }

        switch (message.message_type) {
            case NinchatMessages.NinchatMessageTypes.NinchatJsonMessage:
                return super.test(JSON.stringify((message as NinchatMessages.NinchatJsonMessage).json)) // eslint-disable-line no-extra-parens
            case NinchatMessages.NinchatMessageTypes.NinchatNoticeMessage:
            case NinchatMessages.NinchatMessageTypes.NinchatTextMessage:
                return super.test((message as NinchatMessages.NinchatTextMessage).text) // eslint-disable-line no-extra-parens
            default:
                return false
        }
    }
}
